import { Directive, ElementRef, HostListener, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Directive({ selector: '[selectOnFocus]' })
export class SelectOnFocusDirective {

  constructor(
    private elementRef: ElementRef,
    @Inject(PLATFORM_ID) private platformId: any
  ) { }

  @HostListener('focus', ['$event.target'])
  onFocus(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    this.elementRef.nativeElement.select();
  }
}
